import { DeleteIcon, EditIcon, ResourceMenuActions } from '@all-manager/design-system-v2';
import ConfirmDeleteDialog from '../../../../components/ConfirmDeleteDialog/ConfirmDeleteDialog';
import type { SpaceMemberWithProfile } from '../../types';
import EditMemberModal from '../EditMemberModal/EditMemberModal';
import useMemberMenuAction from './useMemberMenuAction';

// Keeps the French question mark on the sentence's last line.
const NBSP = '\u00A0';

type Props = {
  spaceId: string;
  member: SpaceMemberWithProfile;
  /** Displayed name of the member, used in the menu and confirmation labels. */
  name: string;
};

export default function MemberMenuAction(props: Props) {
  const hook = useMemberMenuAction({ spaceId: props.spaceId, member: props.member });

  return (
    <>
      <ResourceMenuActions
        size="small"
        tooltip={`Options de ${props.name}`}
        actions={[
          {
            id: 'edit',
            label: 'Modifier',
            icon: <EditIcon fontSize="small" />,
            onClick: hook.handleOpenEditModal,
          },
          {
            id: 'remove',
            label: "Retirer de l'espace",
            icon: <DeleteIcon fontSize="small" />,
            onClick: hook.handleOpenRemoveModal,
          },
        ]}
      />

      {hook.isEditModalOpen ? (
        <EditMemberModal spaceId={props.spaceId} member={props.member} onClose={hook.handleCloseEditModal} />
      ) : null}

      {hook.isRemoveModalOpen ? (
        <ConfirmDeleteDialog
          title="Retirer le membre"
          confirmLabel="Retirer"
          onConfirm={hook.handleConfirmRemove}
          onClose={hook.handleCloseRemoveModal}
        >
          Êtes-vous sûr de vouloir retirer {props.name} de cet espace{NBSP}?
        </ConfirmDeleteDialog>
      ) : null}
    </>
  );
}
